/**
 * useAvatarSrc (KAN-618)
 *
 * Source of a Telegram account avatar: the avatar endpoint needs the token, so
 * the picture is loaded through the api client (see useApiFileSrc).
 */
import { telegramAccountsApi } from '@/services/api/telegramAccounts';
import { useApiFileSrc } from './useApiFileSrc';

function fetchAvatar(url: string): Promise<Blob> {
  return telegramAccountsApi.fetchAvatar(url);
}

/**
 * @param url avatar_url from the backend ("" when there is no picture)
 * @param version changes when the picture changes (profile_updated_at); ""
 *   when unknown, then the cached picture is used
 */
export function useAvatarSrc(url: string, version = ''): string | null {
  return useApiFileSrc(url, version, fetchAvatar);
}
